import React, { useEffect, useState } from "react";
import emailjs from "emailjs-com";

export const Contact = () => {
  const [status, setStatus] = useState(0);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  useEffect(() => {
    let timer;
    if (status === 200) {
      timer = setTimeout(() => {
        setStatus(0); 
        setFormData({
          name: "",
          email: "",
          subject: "",
          message: "",
        });// Cambia el estado después de 3 segundos
      }, 3000); // 3000 milisegundos = 3 segundos
    }
    
    return () => {
      clearTimeout(timer); // Limpia el temporizador al desmontar el componente
    };
  }, [status]);

  function enviarEmail(e) {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_8jlj7o9",
        "template_dx6h0kb",
        e.target,
        "TISbpAZ5Rmo2A3Mbz"
      )
      .then((res) => {
        setStatus(res.status);
        setFormData({
          name: "",
          email: "",
          subject: "",
          message: "",
        });
      });
  }

  function handleInputChange(e) {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  }

  return (
    <main id="main" data-aos="fade" data-aos-delay="1500">
      <div class="page-header d-flex align-items-center">
        <div class="container position-relative">
          <div class="row d-flex justify-content-center">
            <div class="col-lg-6 text-center">
              <h2>Contactame</h2>
              <p>
                Si quieres alguna colaboracon conmigo, no dudes en comunicarte.
                SOLO NEGOCIOS
              </p>
            </div>
          </div>
        </div>
      </div>

      <section id="contact" class="contact">
        <div class="container">
          <div class="row gy-4 justify-content-center">
            <div class="col-lg-3">
              <div class="info-item d-flex">
                <i class="bi bi-geo-alt flex-shrink-0"></i>
                <div>
                  <h4>Location:</h4>
                  <p>Un lugar lejano</p>
                </div>
              </div>
            </div>

            <div class="col-lg-3">
              <div class="info-item d-flex">
                <i class="bi bi-envelope flex-shrink-0"></i>
                <div>
                  <h4>Email:</h4>
                  <p>eencarnacion310@gmail.com</p>
                </div>
              </div>
            </div>
          </div>

          <div class="row justify-content-center mt-4">
            <div class="col-lg-9">
              <form
                name="contact v1"
                onSubmit={enviarEmail}
                class="php-email-form"
              >
                <div class="row">
                  <div class="col-md-6 form-group">
                    <input
                      type="text"
                      name="name"
                      class="form-control"
                      id="name"
                      onChange={(e)=>handleInputChange(e)}
                      placeholder="Your Name"
                      value={formData.name}
                      required
                    />
                  </div>
                  <div class="col-md-6 form-group mt-3 mt-md-0">
                    <input
                      type="email"
                      class="form-control"
                      name="email"
                      onChange={(e)=>handleInputChange(e)}
                      value={formData.email}

                      id="email"
                      placeholder="Your Email"
                      required
                    />
                  </div>
                </div>
                <div class="form-group mt-3">
                  <input
                    type="text"
                    class="form-control"
                    name="subject"
                    id="subject"
                    onChange={(e)=>handleInputChange(e)}
                    value={formData.subject}

                    placeholder="Subject"
                    required
                  />
                </div>
                <div class="form-group mt-3">
                  <textarea
                    class="form-control"
                    name="message"
                    rows="5"
                    onChange={(e)=>handleInputChange(e)}
                    placeholder="Message"
                    value={formData.message}

                    required
                  ></textarea>
                </div>
                {status === 200 && (
                  <>
                    <div class="alert alert-secondary" role="alert">
                      Datos enviados correctamente!!
                    </div>


                  </>
                )}
                <div class="text-center">
                  <button type="submit">Enviar mensaje</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};
